import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.27.6/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.27.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mixNumber as mixNumber$1 } from './number.mjs';
import { mixColor } from './color.mjs';
import { pipe } from '../pipe.mjs';
import { warning } from 'motion-utils';
import { color } from '../../value/types/color/index.mjs';
import { complex, analyseComplexValue } from '../../value/types/complex/index.mjs';
import { isCSSVariableToken } from '../../render/dom/utils/is-css-variable.mjs';
import { invisibleValues, mixVisibility } from './visibility.mjs';
import { mixImmediate } from './immediate.mjs';
function mixNumber(a, b) {
  return function (p) {
    return mixNumber$1(a, b, p);
  };
}
function getMixer(a) {
  if (typeof a === "number") {
    return mixNumber;
  } else if (typeof a === "string") {
    return isCSSVariableToken(a) ? mixImmediate : color.test(a) ? mixColor : mixComplex;
  } else if (Array.isArray(a)) {
    return mixArray;
  } else if (typeof a === "object") {
    return color.test(a) ? mixColor : mixObject;
  }
  return mixImmediate;
}
function mixArray(a, b) {
  var output = _toConsumableArray(a);
  var numValues = output.length;
  var blendValue = a.map(function (v, i) {
    return getMixer(v)(v, b[i]);
  });
  return function (p) {
    for (var i = 0; i < numValues; i++) {
      output[i] = blendValue[i](p);
    }
    return output;
  };
}
function mixObject(a, b) {
  var output = _objectSpread(_objectSpread({}, a), b);
  var blendValue = {};
  for (var key in output) {
    if (a[key] !== undefined && b[key] !== undefined) {
      blendValue[key] = getMixer(a[key])(a[key], b[key]);
    }
  }
  return function (v) {
    for (var _key in blendValue) {
      output[_key] = blendValue[_key](v);
    }
    return output;
  };
}
function matchOrder(origin, target) {
  var _a;
  var orderedOrigin = [];
  var pointers = {
    color: 0,
    var: 0,
    number: 0
  };
  for (var i = 0; i < target.values.length; i++) {
    var type = target.types[i];
    var originIndex = origin.indexes[type][pointers[type]];
    var originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
    orderedOrigin[i] = originValue;
    pointers[type]++;
  }
  return orderedOrigin;
}
var mixComplex = function mixComplex(origin, target) {
  var template = complex.createTransformer(target);
  var originStats = analyseComplexValue(origin);
  var targetStats = analyseComplexValue(target);
  var canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
  if (canInterpolate) {
    if (invisibleValues.has(origin) && !targetStats.values.length || invisibleValues.has(target) && !originStats.values.length) {
      return mixVisibility(origin, target);
    }
    return pipe(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
  } else {
    warning(true, "Complex values '".concat(origin, "' and '").concat(target, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition."));
    return mixImmediate(origin, target);
  }
};
export { getMixer, mixArray, mixComplex, mixObject };